<template>
  <!--Modal for viewing current quiz results-->
  <div class="modal modal-default fade" :id="'examCurrentModal'"> <!--v-if="showCurrentStatistics == true"-->
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header bg-success">
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">×</span>
          </button>
          <div v-if="examResults != null">
            <button type="button" class="btn btn-success pull-left" aria-label="Refresh" @click.prevent="refreshCurrentResults()">
              <!-- <span class="fa fa-refresh" aria-hidden="true"></span> -->
              Osveži
            </button>

            <button type="button" class="btn btn-success pull-left" @click.prevent="showExerciseTitle">
              <!-- <span class="fa fa-refresh" aria-hidden="true"></span> -->
              Prikazi ime vprasanja
            </button>

            <b-dropdown text="Izberi nalogo" variant="primary" class="m-md-2">
              <div v-for="(vprasanje, i) in examResults.vsaVprasanja" :key="'vprasanje-'+i">
                <b-dropdown-item @click.prevent="showCurrentResultsNextExercise(i)">
                  <span v-if="showNameOfQuestion"> {{vprasanje.nameExercise}} </span>
                  <span v-else>{{$t('pages.exams.currentStatistics.ExerciseName')}} {{i+1}}</span>
                </b-dropdown-item>
              </div>
            </b-dropdown>

            <button type="button" class="btn btn-success" aria-label="Show Solution" @click.prevent="showSolution()">
              Prikazi resitev
            </button>
          </div>
        </div>
        <h4 v-if="examResults != null" class="modal-title">{{$t('pages.exams.currentStatistics.ExerciseName')}}
          <span v-if="showNameOfQuestion">{{this.examResults.vsaVprasanja[this.exerciseNumber].nameExercise}}: {{this.examResults.vsaVprasanja[this.exerciseNumber].titleExercise | pickTranslation}}</span>
          <span v-else>{{this.exerciseNumber+1}}</span>
          </h4>
        <div v-if="examResults != null" class="modal-body">

        <span v-html="$options.filters.pickTranslation(examResults.vsaVprasanja[this.exerciseNumber].fullExerciseData.text)"></span>

          <div v-for="(vprasanje, i) in examResults.vsaVprasanja[this.exerciseNumber].naloge" :key="'er-'+vprasanje.nameQuestion" class="form-group">
                <div>
                  <strong v-if="showNameOfQuestion">{{vprasanje.nameQuestion}}</strong>
                  <strong v-else>Vprasanje {{i+1}}:</strong>
                  <br/>
                  <!-- {{vprasanje.titleExercise}}<br/> -->
                  <div v-html="$options.filters.pickTranslation(examResults.vsaVprasanja[exerciseNumber].fullExerciseData.questions[i].text)"></div>

                  <br/>
                  <exercise-results-preview :question="vprasanje" :results="resultsPerExercise[i]" :resultLabels="answersOfExercise[i]" :labelColors="chartColors[i]">
                  </exercise-results-preview>
                  <!-- <exercise :bareBonesExercise="currentExerciseData"></exercise> -->
                  <br/>
                  <div v-if="correctAnswer[i] != null">
                    <strong>{{$t('pages.exams.currentStatistics.answer')}}</strong>{{correctAnswer[i]}}
                  </div>
                </div>
                <!-- col-sm-12 -->

                <!-- Odvde krecu chartovi -->

                <div class="box box-success" v-if="examResults.vsaVprasanja[exerciseNumber].naloge[i].typeQuestion == 'multichoice'">
                  <bar class="" :height="125" :chartData="{labels: answersOfExercise[i], datasets: resultsPerExercise[i]}" :options="{scales: {xAxes: [{stacked: true}], yAxes: [{stacked: true, stepSize: 1}]}, legend: { display: false }}"></bar>
                </div>
                <br>
                <div id="bar-chart" v-if="examResults.vsaVprasanja[exerciseNumber].naloge[i].typeQuestion == 'radio' || examResults.vsaVprasanja[exerciseNumber].naloge[i].typeQuestion == 'numerical' || examResults.vsaVprasanja[exerciseNumber].naloge[i].typeQuestion == 'multichoice'">
                  <!-- <bar class="" :height="125" :chartData="{labels: answersOfExercise[i], datasets: [{label:'stevilo odgovorov', data: resultsPerExercise[i], backgroundColor: chartColors[i], borderColor: chartBorderColors[i], borderWidth: 1}]}"></bar> -->
                  <!-- Horizontal bar chart for Prav/Narobe -->
                  <b-progress height="15px" class="mt-2" :max="100">
                    <b-progress-bar :value="100 * (vprasanje.results[1]/(vprasanje.results[0]+vprasanje.results[1]))" style="background-color:#4aa362"></b-progress-bar>
                    <b-progress-bar :value="100 * (vprasanje.results[0]/(vprasanje.results[0]+vprasanje.results[1]))" style="background-color:#da7162"></b-progress-bar>
                  </b-progress>
                  <div v-if="(vprasanje.results[0]+vprasanje.results[1])>0">
                    <span style="font-size:150%; color:#4aa362" >{{ Math.round(100 * (vprasanje.results[1]/(vprasanje.results[0]+vprasanje.results[1]))) }}%</span>  <span style="font-size:150%; color:#da7162; position:absolute; right:45px;" >{{ Math.round(100 * (vprasanje.results[0]/(vprasanje.results[0]+vprasanje.results[1]))) }}%</span>
                  </div>
                  <div v-else>
                    <span style="font-size:150%; color:lightgray" >{{ 0 }}%</span>  <span style="font-size:150%; color:lightgray; position:absolute; right:45px;" >{{ 0 }}%</span>
                  </div>
                </div>

                <!-- Do ovde idu chartovi -->

                <!--{{examResults}}-->
                <!-- Show Solution -->
                <div v-if="toggleSolution">
                  <div v-if="!examResults.vsaVprasanja[exerciseNumber].fullExerciseData.questions[i].solution">{{ $t('pages.exercise.answers.noSolution') }}</div>
                  <div v-else-if="examResults.vsaVprasanja[exerciseNumber].fullExerciseData.parent != null && examResults.vsaVprasanja[exerciseNumber].fullExerciseData.parent !== null">
                    <div>{{ $t('pages.exercise.answers.parametricSolution2') }}</div>
                    <div v-html="$options.filters.pickTranslation(examResults.vsaVprasanja[exerciseNumber].fullExerciseData.questions[i].solution)"></div>
                  </div>
                  <div v-else v-html="$options.filters.pickTranslation(examResults.vsaVprasanja[exerciseNumber].fullExerciseData.questions[i].solution)"></div>
                </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-primary pull-left" data-dismiss="modal">{{$t('pages.reports.close')}}</button>
          <button v-if="examResults != null" :disabled="exerciseNumber <= 0" type="button" class="btn btn-primary" @click.prevent="showCurrentResultsNextExercise(exerciseNumber-1)">{{$t('pages.exams.currentStatistics.lastExercise')}}</button>
          <button v-if="examResults != null" :disabled="exerciseNumber >= examResults.vsaVprasanja.length-1" type="button" class="btn btn-primary" @click.prevent="showCurrentResultsNextExercise(exerciseNumber+1)">{{$t('pages.exams.currentStatistics.nextExercise')}}</button>
        </div>
      </div>
    </div>
  </div>

</template>
<script>
import Rest from './../../../services/rest'
import ExerciseResultsPreview from '@/components/exercises/ExerciseResultsPreview'
import Bar from '@/charts/Bar.js'
import Pie from '@/charts/Pie.js'
import Line from '@/charts/Line.js'

export default {
  data () {
    return {
      // used for exam statistic inbrowser display
      exerciseNumber: 0,
      examResultsId: 0,
      examResults: null,
      resultsPerExercise: [],
      answersOfExercise: [],
      chartColors: [],
      chartBorderColors: [],
      currentExerciseData: [],
      correctAnswer: [],
      sId: '',
      options: {},
      showNameOfQuestion: false,
      toggleSolution: false,
      wholeParent: []
    }
  },
  components: {
    bar: Bar,
    pie: Pie,
    line: Line,
    'exercise-results-preview': ExerciseResultsPreview
  },
  methods: {
    showSolution () {
      this.toggleSolution = !this.toggleSolution
      this.$nextTick(function () {
        window.MathJax.Hub.Queue(['Typeset', window.MathJax.Hub])
      })
    },
    showExerciseTitle () {
      this.showNameOfQuestion = !this.showNameOfQuestion
    },
    getParent (params) {
      return Rest.request('POST', '/exercises/find', params).then((data) => {
        this.wholeParent = data
        // console.log('tek sada gotov')
        // console.log(this.wholeParent)
      }).catch((err) => {
        console.log(err)
      })
    },
    async obradaPodatkov (data) {
      let zaSplice = []
      // calculating results
      for (let i = 0; i < data.vsaVprasanja.length; i++) {
        for (let j = 0; j < data.vsaVprasanja[i].naloge.length; j++) {
          if (data.vsaVprasanja[i].naloge[j].typeQuestion === 'radio' || data.vsaVprasanja[i].naloge[j].typeQuestion === 'multichoice') {
            for (let k = 0; k < data.vsaVprasanja[i].naloge[j].answers.length; k++) {
              if (data.vsaVprasanja[i].naloge[j].answers[k].result) {
                if (data.vsaVprasanja[i].naloge[j].answers[k].correct) {
                  data.vsaVprasanja[i].naloge[j].results[1] += data.vsaVprasanja[i].naloge[j].answers[k].result
                } else {
                  data.vsaVprasanja[i].naloge[j].results[0] += data.vsaVprasanja[i].naloge[j].answers[k].result
                }
              }
            }
          }
        }
      }
      // eliminating parametric exercises, leaving only one child or parent
      for (let i = 0; i < data.vsaVprasanja.length; i++) {
        if (data.vsaVprasanja[i].fullExerciseData.parent !== null && data.vsaVprasanja[i].fullExerciseData.parent != null) {
          let parent = data.vsaVprasanja[i].fullExerciseData.parent
          parent = parent.substring(0, parent.length - 2) // locim .p sa konca parenta
          // iscem parent nalogo
          let najdio = false
          for (let j = 0; j < data.vsaVprasanja.length; j++) {
            if (data.vsaVprasanja[j].nameExercise === parent) {
              najdio = true
              for (let k = 0; k < data.vsaVprasanja[j].naloge.length; k++) {
                data.vsaVprasanja[j].naloge[k].results[0] = data.vsaVprasanja[j].naloge[k].results[0] + data.vsaVprasanja[i].naloge[k].results[0]
                data.vsaVprasanja[j].naloge[k].results[1] = data.vsaVprasanja[j].naloge[k].results[1] + data.vsaVprasanja[i].naloge[k].results[1]
              }
            }
          }
          // ce parent ni v kvizu, prvi kateri ima istega parenta je "parent"
          if (najdio === false) {
            for (let j = 0; j < i; j++) {
              if (data.vsaVprasanja[j].fullExerciseData.parent === data.vsaVprasanja[i].fullExerciseData.parent) {
                najdio = true
                for (let k = 0; k < data.vsaVprasanja[j].naloge.length; k++) {
                  data.vsaVprasanja[j].naloge[k].results[0] = data.vsaVprasanja[j].naloge[k].results[0] + data.vsaVprasanja[i].naloge[k].results[0]
                  data.vsaVprasanja[j].naloge[k].results[1] = data.vsaVprasanja[j].naloge[k].results[1] + data.vsaVprasanja[i].naloge[k].results[1]
                }
              }
            }
          }
          // ce se vedno nima brata to pomeni da je prvo pojavljivanje naloge tj. ne moremo je Splice ati
          if (najdio === true) {
            zaSplice.push(i)
          }
        }
      }
      // console.log('zaSplice je ', zaSplice)
      for (let i = 0; i < zaSplice.length; i++) {
        // console.log('Spliceao', zaSplice[zaSplice.length - i - 1])
        data.vsaVprasanja.splice(zaSplice[zaSplice.length - i - 1], 1)
      }

      for (let i = 0; i < data.vsaVprasanja.length; i++) {
        // console.log(data.vsaVprasanja[i].fullExerciseData)
        if (data.vsaVprasanja[i].fullExerciseData.parent !== null && data.vsaVprasanja[i].fullExerciseData.parent != null) {
          // console.log(data.vsaVprasanja[i].fullExerciseData)
          let params = {
            identifier: data.vsaVprasanja[i].fullExerciseData.id,
            parentIdentifier: data.vsaVprasanja[i].fullExerciseData.parent
          }
          await this.getParent(params)
          // console.log(this.wholeParent)
          for (let j = 0; j < data.vsaVprasanja[i].fullExerciseData.questions.length; j++) {
            data.vsaVprasanja[i].fullExerciseData.questions[j].solution = this.wholeParent.data.questions[j].solution
          }
        }
      }

      return data
    },
    showCurrentResults (id) {
      // exerciseNumber
      // this.examResults = []
      // this.currentQuiz = id
      this.examResultsId = id
      return Rest.requestForm('GET', '/results/' + id + '/resultsWithStatistic').then(async (data) => {
        // obrada podataka
        this.examResults = await this.obradaPodatkov(data)
        // console.log(JSON.parse(JSON.stringify(this.wholeParent)))
        this.showCurrentResultsNextExercise(0)
        window.jQuery('#examCurrentModal').modal('toggle')
        // console.log(JSON.stringify(this.examResults))
      }).catch((err) => {
        console.log(err)
      })
    },
    refreshCurrentResults () {
      // exerciseNumber
      // this.examResults = []
      return Rest.requestForm('GET', '/results/' + this.examResultsId + '/resultsWithStatistic').then(async (data) => {
        // enako kot showCurrentResults
        // obrada podataka
        this.examResults = await this.obradaPodatkov(data)

        this.showCurrentResultsNextExercise(this.exerciseNumber)
        // window.jQuery('#examCurrentModal').modal('toggle')
        // console.log(this.answersOfQuestion)
      }).catch((err) => {
        console.log(err)
      })
    },
    async showCurrentResultsNextExercise (nextExerciseNumber) {
      this.toggleSolution = false
      let before = async () => {
        this.exerciseNumber = nextExerciseNumber
        console.log('EN:' + nextExerciseNumber)
        this.resultsPerExercise = []
        this.answersOfExercise = []
        this.correctAnswer = []
        // this.currentExerciseData = []
        this.currentExerciseData.splice(0, this.currentExerciseData.length)
        // this.$forceUpdate()
        for (let naloga in this.examResults.vsaVprasanja[this.exerciseNumber].naloge) {
          let stResevalcev = this.examResults.vsaVprasanja[this.exerciseNumber].stResevalcevNaloge
          let question = this.examResults.vsaVprasanja[this.exerciseNumber].naloge[naloga]
          this.currentExerciseData.push(question.titleExercise.sl ? question.titleExercise.sl : question.titleExercise)
          console.log(question.typeQuestion)
          if (question.typeQuestion === 'radio') {
            this.correctAnswer[naloga] = null
            let resultsPerQuestion = [question.answers.length]
            let answersOfQuestion = [question.answers.length]
            this.chartColors[naloga] = [
              'rgba(57, 106, 203, 0.75)',
              'rgba(218, 124, 48, 0.75)',
              'rgba(83, 81, 84, 0.75)',
              'rgba(107, 76, 154, 0.75)',
              'rgba(148, 139, 61, 0.75)',
              'rgba(186, 74, 0, 0.75)',
              'rgba(22, 160, 133, 0.75)',
              'rgba(241, 196, 15, 0.75)',
              'rgba(23, 32, 42, 0.75)']
            this.chartBorderColors[naloga] = [
              'rgba(218,113,98,255)',
              'rgba(218,113,98,255)',
              'rgba(218,113,98,255)',
              'rgba(218,113,98,255)',
              'rgba(218,113,98,255)',
              'rgba(218,113,98,255)',
              'rgba(218,113,98,255)',
              'rgba(218,113,98,255)',
              'rgba(218,113,98,255)']
            let stOdgovorov = 0
            for (let odgovor in question.answers) {
              let trOdgovor = question.answers[odgovor]
              if ('result' in trOdgovor) {
                stOdgovorov += trOdgovor.result
                resultsPerQuestion[odgovor] = trOdgovor.result
              } else {
                resultsPerQuestion[odgovor] = 0
              }
              if (trOdgovor.correct) {
                this.correctAnswer[naloga] = trOdgovor.text.sl
                this.chartColors[naloga][odgovor] = 'rgba(74,163,98,255)'
                this.chartBorderColors[naloga][odgovor] = 'rgba(74,163,98,255)'
              }
              answersOfQuestion[odgovor] = trOdgovor.text.sl
            }
            if (stOdgovorov < stResevalcev) {
              resultsPerQuestion[question.answers.length] = stResevalcev - stOdgovorov
              answersOfQuestion[question.answers.length] = 'Neodgovorjeno'
              this.chartColors[naloga][question.answers.length] = 'rgba(211, 211, 211, 1)'
              this.chartBorderColors[naloga][question.answers.length] = 'rgba(218,113,98,255)'
            }
            // console.log(JSON.stringify(resultsPerQuestion))
            this.resultsPerExercise.push(resultsPerQuestion)
            this.answersOfExercise.push(answersOfQuestion)
          } else if (question.typeQuestion === 'numerical') {
            this.correctAnswer[naloga] = question.answers[0].correct
            this.resultsPerExercise[naloga] = [question.results[0], question.results[1]]
            this.answersOfExercise[naloga] = ['Narobe', 'Prav']
            this.chartColors[naloga] = [
              'rgba(218,113,98,255)',
              'rgba(74,163,98,255)']
            this.chartBorderColors[naloga] = [
              'rgba(218,113,98,255)',
              'rgba(74,163,98,255)']
            let stOdgovorov = this.resultsPerExercise[naloga][0] + this.resultsPerExercise[naloga][1]
            if (stOdgovorov < stResevalcev) {
              this.resultsPerExercise[naloga][2] = stResevalcev - stOdgovorov
              this.answersOfExercise[naloga][2] = 'Neodgovorjeno'
              this.chartColors[naloga][2] = 'rgba(211, 211, 211, 1)'
              this.chartBorderColors[naloga][2] = 'rgba(218,113,98,255)'
            }
          } else if (question.typeQuestion === 'multichoice') {
            let correctAnswersArray = []
            let answersOfQuestion = [question.answers.length]
            let resultsPerQuestion = []
            let resultsPerQuestionTrueGreen = {
              label: 'Res',
              backgroundColor: 'rgba(74,163,98,255)',
              data: []
            }
            let resultsPerQuestionTrueRed = {
              label: 'Res',
              backgroundColor: 'rgba(218,113,98,255)',
              data: []
            }
            let resultsPerQuestionFalseGreen = {
              label: 'Ni res',
              backgroundColor: 'rgba(74,163,98,255)',
              data: []
            }
            let resultsPerQuestionFalseRed = {
              label: 'Ni res',
              backgroundColor: 'rgba(218,113,98,255)',
              data: []
            }
            for (let odgovor in question.answers) {
              let trOdgovor = question.answers[odgovor]
              if (trOdgovor.correct) {
                correctAnswersArray.push(trOdgovor.text.sl)
                if ('result' in trOdgovor) {
                  resultsPerQuestionTrueGreen.data.push(trOdgovor.result)
                  // resultsPerQuestionFalseRed.data.push(stResevalcev - trOdgovor.result)
                  // resultsPerQuestionFalseRed.data.push(0)
                  resultsPerQuestionTrueRed.data.push(0)
                  // resultsPerQuestionFalseGreen.data.push(0)
                } else {
                  resultsPerQuestionTrueGreen.data.push(0)
                  // resultsPerQuestionFalseRed.data.push(stResevalcev)
                  resultsPerQuestionTrueRed.data.push(0)
                  // resultsPerQuestionFalseGreen.data.push(0)
                }
              } else {
                if ('result' in trOdgovor) {
                  resultsPerQuestionTrueGreen.data.push(0)
                  // resultsPerQuestionFalseRed.data.push(0)
                  resultsPerQuestionTrueRed.data.push(trOdgovor.result)
                  // resultsPerQuestionFalseGreen.data.push(stResevalcev - trOdgovor.result)
                } else {
                  resultsPerQuestionTrueGreen.data.push(0)
                  // resultsPerQuestionFalseRed.data.push(0)
                  resultsPerQuestionTrueRed.data.push(0)
                  // resultsPerQuestionFalseGreen.data.push(stResevalcev)
                }
              }
              answersOfQuestion[odgovor] = trOdgovor.text.sl
            }
            resultsPerQuestion.push(resultsPerQuestionTrueGreen)
            resultsPerQuestion.push(resultsPerQuestionFalseRed)
            resultsPerQuestion.push(resultsPerQuestionTrueRed)
            resultsPerQuestion.push(resultsPerQuestionFalseGreen)
            this.correctAnswer[naloga] = correctAnswersArray.toString()
            this.resultsPerExercise.push(resultsPerQuestion)
            this.answersOfExercise.push(answersOfQuestion)
          }
        }
      }
      await before()
      console.log(this.currentExerciseData)
      this.$nextTick(function () {
        window.MathJax.Hub.Queue(
          ['Typeset', window.MathJax.Hub]
        )
        /* var math = window.MathJax.Hub.getAllJax('exerciseStatList')[0]
        window.MathJax.Hub.Queue(['Text', math]) */
      })
      /* this.$forceUpdate()
      if (window.MathJax.Hub.Queue(['needsUpdate', window.MathJax.Hub, 'exerciseStatList'])) {
        this.$nextTick(function () {
          window.MathJax.Hub.Queue(
              // ['Remove', window.MathJax.Hub, 'exerciseStatList'],
            ['Typeset', window.MathJax.Hub, 'exerciseStatList']
            // ['Typeset', window.MathJax.Hub, 'exerciseStatList']
          )
        })
      }
      this.$forceUpdate() */
    }
  }
}
</script>
<style scoped>
.mt-2 {
  border-radius: 10px;
  margin: 0 0 5px 0;
}
#bar-chart {
  margin: 0 30px 0 30px;
}
</style>



// WEBPACK FOOTER //
// ExamResultsPreview.vue?06427529